import { getFitDocToken, getFitDocMetafilter, getFitDocTypes } from "./token";
import { getFiletypes } from "./fetch";
import { subMonths, subWeeks } from "date-fns";
import { dateToYYYYMMDD } from "./conversions";

let allfiles = []

export const getFiles = async (user, startdate, enddate) => {
    if(!startdate){
        if(user.role.toString() === "1"){
            startdate = dateToYYYYMMDD(subWeeks(new Date(), 1))
        }
        else {
            startdate = dateToYYYYMMDD(subMonths(new Date(), 1))
        }
    }
    if(!enddate){
        enddate = dateToYYYYMMDD(new Date())
    }
    //Get all files
    //Get token
    const token = await getFitDocToken(user);

    //Get types
    const types = await getFitDocTypes();

    //Get metafilter
    const metafilter = await getFitDocMetafilter(user);

    return fetch(process.env.REACT_APP_SERVER_LINK+"dossiers?token="+token+"&types="+types.join(";")+"&metafilter="+metafilter+`&startdate=${startdate}&enddate=${enddate}`).catch((error)=>{window.location.href = "/"}).then(
        res => {return res.json();}
    ).then(
        json => {
            if(json){
                if(json.errorcode === 0){
                    const files = json.object;


                    let fileTypesSettings = window.sessionStorage.getItem("filetypeGetAll")

                    return handleFilter(files, fileTypesSettings).then(
                        result => {
                            if(result[0]){
                                for (let i = 0; i < result[0].length; i++) {
                                    if(result[1]){
                                        for (let j = 0; j < result[1].length; j++) {
                                            if(result[0][i].dossierentityid === result[1][j].dossierentityid){
                                                result[1][j].documents = result[0][i].documents
                                            }
                                        }  
                                        return result[1]
                                    }
                                    else {
                                        return "none"
                                    }   
                                }

                                if(result[1]){

                                    result[1] = result[1].filter(file => file.documents && file.documents.length > 0)
                                    if(result[1].length > 0){
                                         return result[1];
                                    }
                                    else {
                                        console.log(result)
                                        return "none"
                                    }
                                   
                                }
                                else {
                                    return "none"
                                }                                
                            }
                            else{
                                if(result[1]){
                                    if(result[1].length > 0 && result[2]){
                                        result[1] = result[1].filter(file => file.documents && file.documents.length > 0)
                                        return result[1]
                                    }
                                    else{
                                        return "none";
                                    }
                                }
                                else{
                                    return "none";
                                }                
                            }
                        }   
                    )
                }
                else{
                    //console.log(json)
                }
            }
            else{
                //console.log("failed to load files", json)
            }          
        }
    )
}

export const getExceptionFiles = () =>{
   return fetch(process.env.REACT_APP_SERVER_LINK+"fileExceptionGetAll?token="+JSON.parse(window.sessionStorage.getItem("user_data")).token+"&role="+JSON.parse(window.sessionStorage.getItem("user_data")).role).then(
        res => res.json()
    ).then(
        json => {
            if(json.errorcode === 0){
                
                return json.object.object
            }
        }
    )
}

export const getExceptionByFile = async (file_id) =>{
    //Get exception
    let f = await fetch(process.env.REACT_APP_SERVER_LINK+"fileExceptionGet?token="+JSON.parse(window.sessionStorage.getItem("user_data")).token+"&fileid="+file_id);
    f = await f.json();
    if(f.errorcode === 0){
        return f.object;
    }
    // return fetch(process.env.REACT_APP_SERVER_LINK+"fileExceptionGet?token="+JSON.parse(window.sessionStorage.getItem("user_data")).token+"&fileid="+file_id).then(
    //     res => res.json()
    // ).then(
    //     json => {
    //         if(json.errorcode === 0){
    //             return json.object
    //         }
    //     }
    // )
}

const filterException = async (file, exception) =>{
    let filteredFile = await filterFiletypeException(file, exception)
    return await filteredFile;
}

export const getFileById = (id) =>{
    
    const token = getFitDocToken(JSON.parse(window.sessionStorage.getItem("user_data")));

    return fetch(process.env.REACT_APP_SERVER_LINK+"dossiers?token="+token+"&dossierentityid="+id+"&types='BEGELEIDDOC;GEZONDCERT;HANDELSDOCUMENT;MAD;NFU;VFAC;VLB;WEEGTICK'").then(
        res => res.json()
    ).then(
        json => {
            if(json.errorcode === 0){
                if(json.object){
                    return json.object
                }
            }
        }
    )
}

const filterFileException = async (files) =>{
    let exceptionFiles = await getExceptionFiles();
    let filteredFiles = [];

    if(exceptionFiles){
        for (let i = 0; i < await exceptionFiles.length; i++) {
            //Get exception
            const exceptionByFile = await getExceptionByFile(exceptionFiles[i]);
            //console.log(exceptionByFile);
            const file = await getFileById(await exceptionFiles[i]);
            //Filter file by exception
            if(await file !== undefined){
                const resultFileException = await filterException(await file, await exceptionByFile);

                //console.log(await resultFileException)
                //Add filtered file to array
                filteredFiles = filteredFiles.concat([await resultFileException]);
            }
        }
    }
    return filteredFiles
}

const filterFiletypeException = (files, exceptions) =>{
    //console.log(files, exceptions)
    let file = files[0];
    if(file && exceptions){
        let doctypes = {}
        for (let i = 0; i < exceptions.doctypes.length; i++) {
            doctypes[exceptions.doctypes[i].doctype] = exceptions.doctypes[i].users
        }

        if(file.documents){
        for (let i = 0; i < file.documents.length; i++) {
            //doctype = file.documents[i].document.doctype
            if(file.documents[i]){
                if(file.documents[i].document){
                    if(doctypes[file.documents[i].document.doctype]){

                        if(doctypes[file.documents[i].document.doctype].includes(parseFloat(JSON.parse(window.sessionStorage.getItem("user_data")).role))){
                            //console.log(file.documents[i], " erin")
                        }
                        else{
                            //console.log(file.documents[i], " eruit")
                            let ind = file.documents.indexOf(file.documents[i]);
                            if (ind > -1) {
                                file.documents.splice(ind, 1);
                                file.documents[ind] = null;
                                file.documents.splice(ind, 1);
                            }
                        }

                    }
                    else{
                        //console.log(file.documents[i], " eruit")
                        let ind = file.documents.indexOf(file.documents[i]);
                        if (ind > -1) {
                            file.documents.splice(ind, 1);
                            file.documents[ind] = null;
                            file.documents.splice(ind, 1);
                        }
                    }
                }
                else{
                    //console.log(file.documents[i], " eruit")
                    let ind = file.documents.indexOf(file.documents[i]);
                    if (ind > -1) {
                        file.documents.splice(ind, 1);
                        file.documents[ind] = null;
                        file.documents.splice(ind, 1);
                    }
                }
            }    
        }
        }
        return file;
    }
}

const filterFiletype = (fls, fts) =>{
    let files = fls;
    let filetypesettings = Object.create(fts);
    if(files && filetypesettings){
        for (let i = 0; i < files.length; i++) {

            if(files[i].documents){      
                for (let k = 0; k < filetypesettings.filetypes.length; k++) {
                    if(filetypesettings.filetypes[k].filetype === files[i].dossiertypeid){
                        for (let j = 0; j < files[i].documents.length; j++) {

                            //Object of doctypes {DOCTYPE: [users], DOCTYPE: [users]...}
                            let doctypes = {}
                            for (let index = 0; index < filetypesettings.filetypes[k].doctypes.length; index++) {
                                doctypes[filetypesettings.filetypes[k].doctypes[index].doctype] = filetypesettings.filetypes[k].doctypes[index].users.map(Number);
                            }

                            if(files[i].documents[j].document){
                                if(doctypes[files[i].documents[j].document.doctype]){
                                    if(doctypes[files[i].documents[j].document.doctype].includes(parseFloat(JSON.parse(window.sessionStorage.getItem("user_data")).role)) === undefined || doctypes[files[i].documents[j].document.doctype].includes(parseFloat(JSON.parse(window.sessionStorage.getItem("user_data")).role)) === false){
                                        //Remove document
                                        let ind = files[i].documents.indexOf(files[i].documents[j]);
                                        ind = files[i].documents.findIndex(v => v.docid === files[i].documents[j].docid)
                                        if (ind > -1) {
                                            files[i].documents.splice(ind, 1);
                                        }
                                    }
                                    else{
                                        //Keep document
                                    }
                                }
                                else {
                                    //Remove document
                                    let ind = files[i].documents.indexOf(files[i].documents[j]);
                                    if (ind > -1) {
                                        files[i].documents.splice(ind, 1);
                                        files[i].documents[ind] = null;
                                        files[i].documents.splice(ind, 1);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    
    return files;
}

const filterFileComplete = (files, filestatus) => {
    if(files){
        let tmp_files = []
        for (let i = 0; i < files.length; i++) {
            if(filestatus.complete.includes(files[i].state)){
                tmp_files = tmp_files.concat(files[i])
            }
        }
        return tmp_files;
    }
    else {
        return []
    }
}

const handleFilter = async (files, fileTypesSettings) =>{
    let _filetypesettings = JSON.parse(fileTypesSettings)
    let _files = files;

    let mltFiles = []

    //Filter on file exception 
    let files_filterException = await filterFileException()
    mltFiles[0] = await files_filterException;
    
    //Filter on filetype settings    
    let files_filterFiletype = []
    files_filterFiletype = filterFiletype(_files, _filetypesettings)
    mltFiles[1] = files_filterFiletype;

    //Check if file is complete (for non-admin users only)
    if(parseFloat(JSON.parse(window.sessionStorage.getItem("user_data")).role) !== 1){
        let filestatus = await getFileStatus(JSON.parse(window.sessionStorage.getItem("user_data")))
        mltFiles[1] = filterFileComplete(files_filterFiletype, filestatus);
    }

    mltFiles[2] = true;

    return mltFiles;
}

export const getFileStatus = async (user) =>{
    let filetypes = await getFileType(user)

    //console.log(filetypes);

    let ft = filetypes.object;

    let obj = {}
    for (let i = 0; i < ft.length; i++) {
        obj[ft[i].name] = ft[i].status
    }

    //HARDCODED STATUSSES
    let object = {
        "complete": [4, 7, 10, 13, 16, 19, 22],
        "incomplete": [5, 8, 11, 14, 17, 20, 23]
    }

    return object;
}

export const getFileType = () =>{
    const filetypes = getFiletypes(getFitDocToken(JSON.parse(window.sessionStorage.getItem("user_data"))))
    return filetypes
}